export const sleep = (ms, signal) => new Promise(resolve => {
  if (signal?.aborted) {
    resolve()
    return
  }

  const timer = setTimeout(done, ms)

  function done() {
    signal?.removeEventListener('abort', done)
    clearTimeout(timer)
    resolve()
  }

  signal?.addEventListener('abort', done)
})

export const withTimeout = (promise, ms, onTimeout) => new Promise((resolve, reject) => {
  const timer = setTimeout(() => reject(onTimeout()), ms)
  promise.then(
    value => {
      clearTimeout(timer)
      resolve(value)
    },
    error => {
      clearTimeout(timer)
      reject(error)
    },
  )
})
